// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Components
import { CreateFormQuestionModalVisibility } from '@lyon/scoped-models/form/create/CreateFormQuestionModalVisibility';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { LyonUpdateFormOutlineTabAddQuestion } from './LyonUpdateFormOutlineTabAddQuestion';
import { LyonUpdateFormOutlineTabList } from './LyonUpdateFormOutlineTabList';

// ANCHOR Styles
import { BLOCK } from './styles';

export const LyonUpdateFormSidebarOutlineTab = constant(() => (
  <Block overrides={BLOCK}>
    <LyonUpdateFormOutlineTabList />
    <CreateFormQuestionModalVisibility.Provider>
      <LyonUpdateFormOutlineTabAddQuestion />
    </CreateFormQuestionModalVisibility.Provider>
  </Block>
));
